import Card from 'components/Card/Card.jsx';
import React, { Component } from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import Form from 'react-jsonschema-form';
import { connect } from 'react-redux';
//Redux
import { bindActionCreators } from 'redux';
import fields from '../../lib/fields';
import widgets from '../../lib/widgets';
import * as CollectionsActions from './redux/CollectionsActions';

const schema = {
  definitions: {},
  $schema: 'http://json-schema.org/draft-07/schema#',
  $id: 'http://example.com/root.json',
  type: 'object',
  // title: 'Información',
  required: [],
  properties: {
    title: {
      $id: '#/properties/title',
      type: 'string',
      title: 'Título',
      default: '',
      examples: ['String'],
      pattern: '^(.*)$'
    },
    description: {
      $id: '#/properties/description',
      type: 'string',
      title: 'Descripción',
      default: '',
      examples: ['String'],
      pattern: '^(.*)$'
    },
    order: {
      $id: '#/properties/description',
      type: 'number',
      title: 'Orden',
      default: 10000
    },
    category: {
      $id: '/properties/category',
      type: 'integer',
      title: 'Categoría',
      api: process.env.REACT_APP_URL_API + '/api/categories',
      options: {
        value: 'slug',
        label: 'name'
      },
      default: '',
      examples: ['']
    },
    subcategory: {
      $id: '#/properties/subcategory',
      type: 'string',
      title: 'Subcategoría',
      enum: ['campana', 'lookbook'],
      enumNames: ['Campaña', 'Lookbook']
    },
    cover: {
      $id: '#/properties/cover',
      type: 'string',
      title: 'Portada'
    },
    mainGallery: {
      $id: '#/properties/mainGallery',
      type: 'object',
      title: 'The Maingallery Schema',
      required: ['wide', 'tall', 'squared1'],
      properties: {
        wide: {
          $id: '#/properties/mainGallery/properties/wide',
          type: 'string',
          title: 'Ancho',
          default: '',
          examples: ['String'],
          pattern: '^(.*)$'
        },
        tall: {
          $id: '#/properties/mainGallery/properties/tall',
          type: 'string',
          title: 'Alto',
          default: '',
          examples: ['String'],
          pattern: '^(.*)$'
        },
        squared1: {
          $id: '#/properties/mainGallery/properties/squared1',
          type: 'string',
          title: 'Cuadrada',
          default: '',
          examples: ['String'],
          pattern: '^(.*)$'
        }
      }
    },
    galleries: {
      $id: '#/properties/galleries',
      type: 'array',
      title: 'Galería',
      items: {
        $id: '#/properties/galleries/items',
        type: 'object',
        title: 'Sección',
        required: [],
        properties: {
          wide: {
            $id: '#/properties/galleries/items/properties/wide',
            type: 'array',
            title: 'Ancho'
          },
          tall: {
            $id: '#/properties/galleries/items/properties/tall',
            type: 'array',
            title: 'Alto'
          },
          squared1: {
            $id: '#/properties/galleries/items/properties/squared1',
            type: 'array',
            title: 'Cuadrado'
          },
          squared2: {
            $id: '#/properties/galleries/items/properties/squared2',
            type: 'array',
            title: 'Cuadrado 2'
          }
        }
      }
    }
  }
};

const uiSchema = {
  mainGallery: {
    wide: {
      'ui:field': 'UploadField'
    },
    tall: {
      'ui:field': 'UploadField'
    },
    squared1: {
      'ui:field': 'UploadField'
    }
  },
  category: {
    'ui:widget': 'SelectRemoteWidget'
  },
  cover: {
    'ui:field': 'UploadField'
  },
  galleries: {
    items: {
      wide: {
        'ui:field': 'UploadField'
      },
      tall: {
        'ui:field': 'UploadField'
      },
      squared1: {
        'ui:field': 'UploadField'
      },
      squared2: {
        'ui:field': 'UploadField'
      }
    }
  }
};

const log = type => console.log.bind(console, type);

class CollectionsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      openConfirm: false,
      openSuccess: false
    };

    console.log('Props', props.match.params);
  }

  componentWillMount() {
    if (this.state.id !== 'create') this.props.findById(this.state.id);
  }

  onSubmit = ({ formData }) => {
    let _this = this;
    console.log('Data submitted: ', formData);
    if (
      formData.password === '' ||
      formData.password === undefined ||
      formData.password == null
    )
      delete formData.password;

    if (this.state.id !== 'create') {
      this.props.update(formData.id, formData).then(function() {
        _this.props.history.push('/admin/collections');
      });
    } else {
      this.props.create(formData).then(function() {
        _this.props.history.push('/admin/collections');
      });
    }
  };

  onDelete(confirm = false) {
    let _this = this;
    if (confirm) {
      this.props.remove(this.state.id).then(function() {
        _this.props.history.push('/admin/collections');
      });
    } else {
      this.setState({ openConfirm: true });
    }
  }

  onBlur = (id, value) => {
    console.log('Data submitted: ', this.state.formData);
  };

  render() {
    let { history, Collections } = this.props;
    let { id, openConfirm, openSuccess } = this.state;
    return (
      <div className="main-content">
        {openConfirm && (
          <SweetAlert
            warning
            style={{ display: 'block', marginTop: '-100px' }}
            title="¿Estás Seguro?"
            onConfirm={() => this.onDelete(true)}
            onCancel={() => this.setState({ openConfirm: false })}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Si, borrar!"
            cancelBtnText="Cancelar"
            showCancel
          >
            No podrás desaser está opción!
          </SweetAlert>
        )}

        {openSuccess && (
          <SweetAlert
            success
            style={{ display: 'block', marginTop: '-100px' }}
            title="Listo!"
            confirmBtnBsStyle="info"
            onConfirm={() => this.setState({ openSuccess: false })}
          >
            Se ha actualizado correctamente!
          </SweetAlert>
        )}

        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={<legend>Editar Colección</legend>}
                content={
                  <div>
                    <Form
                      schema={schema}
                      widgets={widgets}
                      fields={fields}
                      uiSchema={uiSchema}
                      onSubmit={this.onSubmit}
                      onBlur={this.onBlur}
                      formData={Collections.formData}
                      onError={log('errors')}
                    >
                      <div>
                        <Button
                          bsStyle="success"
                          type="submit"
                          className="btn-fill"
                        >
                          Guardar
                        </Button>{' '}
                        <Button
                          bsStyle="default"
                          onClick={() => history.push('/admin/collections')}
                        >
                          Cancelar
                        </Button>
                        <div className="pull-right">
                          {id !== 'create' ? (
                            <Button
                              bsStyle="danger"
                              onClick={() => this.onDelete(false)}
                            >
                              Borrar
                            </Button>
                          ) : null}
                        </div>
                      </div>
                    </Form>

                    <div className="clearfix" />
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    Collections: state.Collections
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(CollectionsActions, dispatch);
};

const CollectionsConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(CollectionsForm);

export default CollectionsConnect;



// WEBPACK FOOTER //
// ./src/views/Collections/CollectionsForm.jsx